var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"media-icon"},[_c('a',{attrs:{"target":"_blank","href":_vm.url}},[_c('i',{class:_vm.faClass})]),_c('div',{staticClass:"media-name"},[_c('a',{attrs:{"target":"_blank","href":_vm.url}},[_vm._v(_vm._s(_vm.name))])])])}
var staticRenderFns = []

export { render, staticRenderFns }